 export const API_AUTH_URL = process.env.REACT_APP_API_AUTH_URL || 'https://app.rakeshbansalventures.com';
//  export const API_AUTH_URL = process.env.REACT_APP_API_AUTH_URL || 'http://localhost:9097';
// export const API_AUTH_URL = process.env.REACT_APP_API_AUTH_URL || 'http://127.0.0.1:8000';
// export const API_AUTH_URL = process.env.REACT_APP_API_AUTH_URL || 'https://fg6h40c4-8000.inc1.devtunnels.ms';
 export const API_COURSE_URL = process.env.REACT_APP_API_COURSE_URL || 'https://app.rakeshbansalventures.com';
//  export const API_COURSE_URL = process.env.REACT_APP_API_COURSE_URL || 'http://localhost:9097';
// export const API_COURSE_URL = process.env.REACT_APP_API_COURSE_URL || 'http://localhost:9097';
//  export const API_COURSE_URL = process.env.REACT_APP_API_COURSE_URL || 'https://fg6h40c4-9097.inc1.devtunnels.ms';
export const AUTH_TOKEN_KEY = 'AUTH_TOKEN';
export const PASSWORD_MIN_LENGTH = 8;
export const PHONE_REGEX = /^[0-9]{10,15}$/;

export const API_TIMEOUT = 30000; 
export const RETRY_COUNT = 3;
export const RETRY_DELAY = 1000;
